import { render, staticRenderFns } from "./sales-important.vue?vue&type=template&id=a464ade0"
import script from "./sales-important.vue?vue&type=script&lang=js"
export * from "./sales-important.vue?vue&type=script&lang=js"
import style0 from "./sales-important.vue?vue&type=style&index=0&id=a464ade0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports